<template>
    <transition>
            <div v-if="gallery" class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5">
                <div class="max-w-[960px] w-full px-4 py-4 flex flex-col relative">
                    <div class="relative h-[540px] max-w-[960px] rounded-2xl border border-white bg-gray-200 grid">
                        <button class="absolute right-3 top-3" @click="gallery = ''">
                            <Icon name="Fechar" class="!text-black" />
                        </button>
                        <circle
                            v-if="gallery.photos.length > 1"
                            @click="previousSlide()"
                            class="bg-white h-6 w-6 rounded-full absolute top-1/2 -mt-3 ml-2 cursor-pointer"
                            ><Icon name="SetaEsquerda"
                        /></circle>
                        <circle
                            v-if="gallery.photos.length > 1"
                            @click="nextSlide()"
                            class="bg-white h-6 w-6 rounded-full absolute top-1/2 -mt-3 mr-2 right-0 cursor-pointer"
                            ><Icon name="SetaDireita"
                        /></circle>
                        <img class="max-h-[540px] w-full object-contain rounded-2xl self-center" :src="gallery.exhibition" alt="">
                    </div>

                    <div v-if="gallery.photos.length > 1" class="relative">
                        <div class="grid grid-flow-col gap-x-5 overflow-x-scroll mt-7 no-scroll-bar" @mouseenter="useMouseScroll()" ref="slides">
                            <div class="relative h-[135px] w-[240px] rounded-2xl border border-white cursor-pointer" v-for="(item,key) in gallery.photos" :key="key" @click="gallery.exhibition = item" ref="slide">
                                <div class="absolute rounded-2xl right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-0 hover:bg-opacity-50 hover:block"></div>
                                <img class="h-full w-full rounded-2xl" :src="item" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";
export default {
    components: {
        Icon
    },
    props: {
        gallery: Array
    },
    methods: {
         nextSlide() {
             console.log({refs:this.$refs})
            let obj = this.$refs.slides;

            let exhibition = this.gallery.exhibition;
            let photos = this.gallery.photos;
            let indexCurrent = photos.indexOf(exhibition);
            let indexNext = indexCurrent+1;

            obj.scrollLeft = (258*(indexNext+1))-(obj.clientWidth*0.60);
                console.log(obj.scrollLeft);

            if(indexNext < photos.length) {
                this.gallery.exhibition = photos[photos.indexOf(exhibition)+1];
            }
        },
        previousSlide() {
            let obj = this.$refs.slides;

            let exhibition = this.gallery.exhibition;
            let photos = this.gallery.photos;
            let indexPrevious = photos.indexOf(exhibition)-1;

            obj.scrollLeft = (258*(indexPrevious+1))-(obj.clientWidth*0.60);
            if(indexPrevious >= 0) {
                this.gallery.exhibition = photos[photos.indexOf(exhibition)-1];
            }
        },
        useMouseScroll() {
            const scrollContainer = this.$refs.slides;

            scrollContainer.addEventListener("wheel", (evt) => {
                evt.preventDefault();
                scrollContainer.scrollLeft += evt.deltaY;
            });
        },
    }
}
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
/* .no-scroll-bar::-webkit-scrollbar {
    display: none;
} */

/* Hide scrollbar for IE, Edge and Firefox */
/* .no-scroll-bar {
    -ms-overflow-style: none;
    scrollbar-width: none;
} */
</style>
